import { render, staticRenderFns } from "./CCMajorBtn.vue?vue&type=template&id=16f3ebde&scoped=true&"
import script from "./CCMajorBtn.vue?vue&type=script&lang=ts&"
export * from "./CCMajorBtn.vue?vue&type=script&lang=ts&"
import style0 from "./CCMajorBtn.vue?vue&type=style&index=0&id=16f3ebde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f3ebde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardActions,VCol,VHover,VIcon})
